import { render, staticRenderFns } from "./SidebarObjectsInput.vue?vue&type=template&id=545cb83f&scoped=true&"
import script from "./SidebarObjectsInput.vue?vue&type=script&lang=js&"
export * from "./SidebarObjectsInput.vue?vue&type=script&lang=js&"
import style0 from "./SidebarObjectsInput.vue?vue&type=style&index=0&id=545cb83f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "545cb83f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VIcon,VRow,VSpacer})
